import { Dispatch, SetStateAction } from 'react'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import { ActionList, ActionListItemProps, Avatar, Icon } from '@node-space/ui-components'
import { Link } from '../Link'
import { CurrencyItem } from './ProtocolCard'

interface ProtocolDialogContentProps {
  optionsForSelect: CurrencyItem[]
  selectedCurrencyCode: string
  setShowProtocolModal?: Dispatch<SetStateAction<boolean>>
  setProtocol: Dispatch<SetStateAction<string>>
  isMobile?: boolean
}

export const ProtocolDialogContent = ({
  optionsForSelect,
  selectedCurrencyCode,
  setShowProtocolModal,
  setProtocol,
  isMobile,
}: ProtocolDialogContentProps) => {
  const t = useTranslations()

  const handleOnProtocolSelect = (currency: CurrencyItem) => {
    setShowProtocolModal?.(false)
    setProtocol?.(currency?.value)
  }

  const protocolContainerClass = clsx({
    'max-h-[230px]': isMobile,
    'max-h-[500px]': !isMobile,
  })

  const actionListItems: ActionListItemProps[] = optionsForSelect.map(currency => {
    const avatarName =
      currency?.value === selectedCurrencyCode
        ? selectedCurrencyCode
        : `${selectedCurrencyCode}-${currency?.value?.toLowerCase()}`

    return {
      id: currency?.value,
      title: `${currency?.network} (${currency?.label})`,
      Avatar: <Avatar type="currency" name={avatarName} />,
      onItemClick: () => handleOnProtocolSelect(currency),
      className: 'bg-background-card rounded mb-3 py-3 px-4',
    } as ActionListItemProps
  })

  return (
    <div className="flex flex-col">
      {isMobile && (
        <h1 className="text-foreground-prominent pb-6 pt-4 text-lg font-semibold">
          {t('chooseProtocolFor', {
            currencyCode: selectedCurrencyCode?.toUpperCase(),
          })}
        </h1>
      )}

      <div className={clsx('overflow-y-auto', protocolContainerClass)}>
        <ActionList id="protocol-dialog-content" items={actionListItems} border={false} />
      </div>

      <div className={clsx('flex flex-col items-center gap-6 pb-6', isMobile && 'pt-3')}>
        <p className="text-foreground-subdued text-center text-sm">{t('incorrectProtocol')}</p>

        <Link href={process.env.NEXT_PUBLIC_LEARN_MORE_URL || ''}>
          <div className="flex flex-row items-center">
            <div className="text-accent-status-info pr-1">
              <Icon name="Question" />
            </div>
            {t('notSureWhichProtocolToChoose')}
          </div>
        </Link>
      </div>
    </div>
  )
}
